import { MemberTableRow } from '@/components/pages/kiosk/monitor/StaffMonitor';
import React from 'react';
import { TrackingSubject } from '@/components/pages/kiosk/monitor/StaffMonitor/StaffMonitor';
import { TableSettings } from '@/components/pages/kiosk/monitor/StaffMonitor/components/TableSettings';

interface TableSectionProps {
  entries: TrackingSubject[];
  timeOfDay: number;
  compact?: boolean;
  settings: TableSettings;
  date: string;
  isLiveView: boolean;
  disableRowClick?: boolean;
}

const TableSection = ({
  entries,
  timeOfDay,
  compact,
  settings,
  date,
  isLiveView,
  disableRowClick,
}: TableSectionProps) => (
  <>
    {entries.map((member, index) => (
      <MemberTableRow
        key={index}
        {...member}
        timeOfDay={timeOfDay}
        compact={compact}
        settings={settings}
        date={date}
        isLiveView={isLiveView}
        disableRowClick={disableRowClick}
      />
    ))}
  </>
);

export default TableSection;
